import React from 'react';
export const Flag = () => /*#__PURE__*/React.createElement("svg", {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.52 4v16M6.52 5.6h8.96c2.16 0 2.64 1.2 1.12 2.72l-.96.96c-.64.64-.64 1.68 0 2.24l.96.96c1.52 1.52.96 2.72-1.12 2.72H6.52",
  stroke: "currentColor",
  strokeWidth: "1.2",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));